var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogFormVisible,
        "close-on-click-modal": false,
        width: "600px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogFormVisible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "80px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "项目名称", prop: "name" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入项目名称" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "项目类型", prop: "type" } },
            [
              _c(
                "vab-query-form-left-panel",
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入项目类型" },
                    model: {
                      value: _vm.form.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "type", $$v)
                      },
                      expression: "form.type",
                    },
                  }),
                ],
                1
              ),
              _c(
                "vab-query-form-right-panel",
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "选择属性",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.form.property,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "property", $$v)
                        },
                        expression: "form.property",
                      },
                    },
                    _vm._l(_vm.propertyOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "水印选择", prop: "watermark" } },
            [
              _c(
                "el-checkbox-group",
                {
                  attrs: { size: "medium" },
                  model: {
                    value: _vm.form.watermark,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "watermark", $$v)
                    },
                    expression: "form.watermark",
                  },
                },
                _vm._l(_vm.watermarkOptions, function (item, index) {
                  return _c(
                    "el-checkbox",
                    {
                      key: index,
                      attrs: { label: item.value, disabled: item.disabled },
                    },
                    [_vm._v(" " + _vm._s(item.label) + " ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "项目来源", prop: "source" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "请选择项目来源",
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.form.source,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "source", $$v)
                    },
                    expression: "form.source",
                  },
                },
                _vm._l(_vm.resourceOptions, function (item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { label: item.name, value: item.key },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.save },
            },
            [_vm._v(" 确 定 ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }